import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { errorMessages } from 'constants/messages';
import { throwErrorToast, getOAuth2StartUrl } from 'utils';
import { expirioApi } from 'store/expirio/expirioApi';

export const expirioApiQueryErrorLogger: Middleware = () => next => action => {
    if (action.type.split('/')[0] === expirioApi.reducerPath && isRejectedWithValue(action)) {
        switch (action?.payload?.originalStatus || action?.payload?.status) {
            case 400:
                throwErrorToast({
                    message:
                        action.payload?.data?.errors?.[0]?.ErrorMessage ??
                        action.payload?.data?.detail ??
                        action.payload?.data?.title ??
                        errorMessages[400],
                    action,
                    errorCode: 400,
                });
                break;

            case 401:
                throwErrorToast({
                    message: errorMessages[401],
                    action,
                    errorCode: 401,
                });
                location.replace(getOAuth2StartUrl());
                break;

            case 403:
                console.warn(`Type: ${action.type}`);
                console.warn(`We got a rejected action in API! (ERROR CODE 403) - ${action.meta.arg.endpointName}`);
                console.warn(action.payload);
                break;

            case 404:
                throwErrorToast({
                    message: action.payload?.data?.title ?? action.payload?.data?.detail ?? errorMessages[404],
                    action,
                    errorCode: 404,
                });
                break;

            case 409:
                throwErrorToast({
                    message: errorMessages[409],
                    action,
                    errorCode: 409,
                });
                break;

            default:
                throwErrorToast({
                    message: errorMessages[500],
                    action,
                    errorCode: 500,
                });
                break;
        }
    }

    return next(action);
};
